import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
const SiteCtx = createContext({});

export function Providers({ children }) {
  const [user, setUser] = useState(null);
  const [site, setSite] = useState({});
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);
  useEffect(() => {
    refresh();
    api.get("/settings").then((r) => setSite(r.data)).catch(() => {});
  }, [refresh]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return (
    <SiteCtx.Provider value={site}>
      <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>
    </SiteCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export const useSite = () => useContext(SiteCtx);
export const isStaff = (u) => u && ["admin", "registrar", "staff", "instructor", "accounting"].includes(u.role);
